import script from "./ModalEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEvento.vue?vue&type=script&setup=true&lang=js"

import "./ModalEvento.vue?vue&type=style&index=0&id=a6f085ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6f085ae"]])

export default __exports__